import React, { ReactNode } from 'react'

import ArtisanHeader, { ArtisanHeaderProps } from '../ArtisanHeader'
import ArtisanFooter from '../ArtisanFooter'
import ScrollToTop from '../ScrollToTop'
import ArtisanBackground from '../ArtisanBackground'
import AdobeFonts from '@atoms/AdobeFonts'
import CookieConsent from '@src/components/CookieConsent'
import { useTranslation } from '@models/Translation'

import '@src/assets/app.sass'
import * as style from './style.module.sass'

type ArtisanLayoutProps = {
  showScrollToTopOnPc?: boolean
  enableDissolve?: boolean
  children: ReactNode
} & ArtisanHeaderProps

const ArtisanLayout: React.FC<ArtisanLayoutProps> = ({
  handleClickHeading,
  showScrollToTopOnPc = false,
  enableDissolve = true,
  children,
}) => {
  const { locale } = useTranslation()

  return (
    <div
      className={style.layout}
      data-locale={locale}
      data-dissolve={enableDissolve}
    >
      <AdobeFonts />
      <ArtisanHeader handleClickHeading={handleClickHeading} />
      {children}
      <ScrollToTop showOnPc={showScrollToTopOnPc} />
      <ArtisanFooter />
      <CookieConsent />
      <ArtisanBackground />
    </div>
  )
}

export default ArtisanLayout
